import { css } from "@emotion/react";

export const previewList = ({
  maxItemsUploaded,
}: {
  maxItemsUploaded: boolean;
}) =>
  css({
    display: "flex",
    position: "relative",
    flexDirection: "column",
    gap: 5,
    padding: maxItemsUploaded ? "15px" : "0 15px 15px",
  });
export const chipsPreviewList = ({
  maxItemsUploaded,
}: {
  maxItemsUploaded: boolean;
}) =>
  css({
    display: "flex",
    gap: 5,
    padding: maxItemsUploaded ? "15px" : "0 15px 15px",
  });
